"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.spikes = exports.money2020 = exports.lionsLive = exports.lionsCreativity = exports.dcl = exports.cannesLions = exports.ascential = exports.horizon = void 0;

var _lodash = _interopRequireDefault(require("lodash.defaultsdeep"));

var _fonts = _interopRequireDefault(require("./fonts"));

var _textStyles = _interopRequireDefault(require("./textStyles"));

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

var _colors = _interopRequireDefault(require("./colors"));

var _mediaQueries = _interopRequireDefault(require("./mediaQueries"));

var _space = _interopRequireDefault(require("./space"));

var _Accordion = _interopRequireDefault(require("../components/Accordion/Accordion.themes"));

var _AccordionVariant = _interopRequireDefault(require("../components/AccordionVariant/AccordionVariant.themes"));

var _Announcement = _interopRequireDefault(require("../components/Announcement/Announcement.themes"));

var _Avatar = _interopRequireDefault(require("../components/Avatar/Avatar.themes"));

var _Banner = _interopRequireDefault(require("../components/Banner/Banner.themes"));

var _Breadcrumbs = _interopRequireDefault(require("../components/Breadcrumbs/Breadcrumbs.themes"));

var _Button = _interopRequireDefault(require("../components/Button/Button.themes"));

var _Cards = _interopRequireDefault(require("../components/Cards/Cards.themes"));

var _Carousel = _interopRequireDefault(require("../components/Carousel/Carousel.themes"));

var _FeaturePanel = _interopRequireDefault(require("../components/FeaturePanel/FeaturePanel.themes"));

var _PrimaryFooter = _interopRequireDefault(require("../components/Footer/FooterVariants/PrimaryFooter/PrimaryFooter.themes"));

var _MenuFooter = _interopRequireDefault(require("../components/Footer/FooterVariants/MenuFooter/MenuFooter.themes"));

var _GlobalNav = _interopRequireDefault(require("../components/GlobalNav/GlobalNav.themes"));

var _Header = _interopRequireDefault(require("../components/Header/Header.themes"));

var _Hero = _interopRequireDefault(require("../components/Hero/Hero.themes"));

var _Icon = _interopRequireDefault(require("../components/Icon/Icon.themes"));

var _Layout = _interopRequireDefault(require("../components/Layout/Layout.themes"));

var _LivePlayer = _interopRequireDefault(require("../components/LivePlayer/LivePlayer.themes"));

var _MarkdownRenderer = _interopRequireDefault(require("../components/MarkdownRenderer/MarkdownRenderer.themes"));

var _Nav = _interopRequireDefault(require("../components/Nav/Nav.themes"));

var _NavItem = _interopRequireDefault(require("../components/NavItem/NavItem.themes"));

var _Navigation = _interopRequireDefault(require("../components/Navigation/Navigation.themes"));

var _Portrait = _interopRequireDefault(require("../components/Portrait/Portrait.themes"));

var _Quote = _interopRequireDefault(require("../components/Quote/Quote.themes"));

var _SectionHeader = _interopRequireDefault(require("../components/SectionHeader/SectionHeader.themes"));

var _Spacer = _interopRequireDefault(require("../components/Spacer/Spacer.themes"));

var _Toggle = _interopRequireDefault(require("../components/Toggle/Toggle.themes"));

var _ImageGrid = _interopRequireDefault(require("../components/ImageGrid/ImageGrid.themes"));

var _OptionList = _interopRequireDefault(require("../components/OptionList/OptionList.themes"));

var _Billboard = _interopRequireDefault(require("../components/Billboard/Billboard.themes"));

var _Pagination = _interopRequireDefault(require("../components/Pagination/Pagination.themes"));

var _Select = _interopRequireDefault(require("../components/Select/Select.themes"));

var _Divider = _interopRequireDefault(require("../components/Divider/Divider.themes"));

var _Strip = _interopRequireDefault(require("../components/Strip/Strip.themes")); // Utilities
// Component Themes


var meta = {
  horizon: {
    name: 'Horizon',
    slug: 'horizon'
  },
  cannesLions: {
    name: 'Cannes Lions',
    slug: 'cannesLions'
  },
  lionsLive: {
    name: 'Lions Live',
    slug: 'lionsLive'
  },
  money2020: {
    name: 'Money 20/20',
    slug: 'money2020'
  },
  spikes: {
    name: 'Spikes Asia',
    slug: 'spikes'
  },
  ascential: {
    name: 'Ascential',
    slug: 'ascential'
  },
  dcl: {
    name: 'Digital Commerce Live',
    slug: 'dcl'
  },
  lionsCreativity: {
    name: 'Lions Creativity',
    slug: 'lionsCreativity'
  }
};

var getTheme = function getTheme(brand) {
  return _objectSpread(_objectSpread({}, meta[brand]), {}, {
    accordion: _objectSpread({}, _Accordion.default[brand]),
    accordionVariant: _objectSpread({}, _AccordionVariant.default[brand]),
    announcements: _objectSpread({}, _Announcement.default[brand]),
    avatar: _objectSpread({}, _Avatar.default[brand]),
    banner: _objectSpread({}, _Banner.default[brand]),
    breakpoints: _breakpoints.default,
    breadcrumbs: _objectSpread({}, _Breadcrumbs.default[brand]),
    button: _objectSpread({}, _Button.default[brand]),
    cards: _objectSpread({}, _Cards.default[brand]),
    carousel: _objectSpread({}, _Carousel.default[brand]),
    colors: _objectSpread({}, _colors.default[brand]),
    featurePanels: _objectSpread({}, _FeaturePanel.default[brand]),
    fonts: _objectSpread({}, _fonts.default[brand]),
    footer: _objectSpread({}, _PrimaryFooter.default[brand]),
    menuFooter: _objectSpread({}, _MenuFooter.default[brand]),
    globalNav: _objectSpread({}, _GlobalNav.default[brand]),
    header: _objectSpread({}, _Header.default[brand]),
    hero: _objectSpread({}, _Hero.default[brand]),
    icons: _objectSpread({}, _Icon.default[brand]),
    layout: _objectSpread({}, _Layout.default[brand]),
    livePlayer: _objectSpread({}, _LivePlayer.default[brand]),
    markdown: _objectSpread({}, _MarkdownRenderer.default[brand]),
    mediaQueries: _mediaQueries.default,
    nav: _objectSpread({}, _Nav.default[brand]),
    navItem: _objectSpread({}, _NavItem.default[brand]),
    navigation: _objectSpread({}, _Navigation.default[brand]),
    portrait: _objectSpread({}, _Portrait.default[brand]),
    quotes: _objectSpread({}, _Quote.default[brand]),
    sectionHeader: _objectSpread({}, _SectionHeader.default[brand]),
    space: _space.default,
    spacing: _objectSpread({}, _Spacer.default[brand]),
    textStyles: _objectSpread({}, _textStyles.default[brand]),
    toggle: _objectSpread({}, _Toggle.default[brand]),
    imageGrid: _objectSpread({}, _ImageGrid.default[brand]),
    optionList: _objectSpread({}, _OptionList.default[brand]),
    billboard: _objectSpread({}, _Billboard.default[brand]),
    pagination: _objectSpread({}, _Pagination.default[brand]),
    select: _objectSpread({}, _Select.default[brand]),
    divider: _objectSpread({}, _Divider.default[brand]),
    strip: _objectSpread({}, _Strip.default[brand])
  });
};

var horizon = getTheme('horizon'); // using lodash.defaultsDeep to map horizon defaults to any unassigned tokens

exports.horizon = horizon;
var ascential = (0, _lodash.default)(getTheme('ascential'), horizon);
exports.ascential = ascential;
var cannesLions = (0, _lodash.default)(getTheme('cannesLions'), horizon);
exports.cannesLions = cannesLions;
var dcl = (0, _lodash.default)(getTheme('dcl'), horizon);
exports.dcl = dcl;
var lionsCreativity = (0, _lodash.default)(getTheme('lionsCreativity'), horizon);
exports.lionsCreativity = lionsCreativity;
var lionsLive = (0, _lodash.default)(getTheme('lionsLive'), horizon);
exports.lionsLive = lionsLive;
var money2020 = (0, _lodash.default)(getTheme('money2020'), horizon);
exports.money2020 = money2020;
var spikes = (0, _lodash.default)(getTheme('spikes'), horizon);
exports.spikes = spikes;